const MonitoringInfoCard = () => {
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
      <div className="flex items-center gap-1.5 mb-2">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-information-line text-amber-600 text-xs"/>
        </div>
        <h4 className="text-xs font-semibold text-slate-700">생활 모니터링 기준</h4>
      </div>
      <p className="text-xs text-slate-500 leading-relaxed" style={{ wordBreak: "keep-all" }}>
        생활 모니터링은 일정 응답, 소리 분석, 기기 상태, 긴급 이벤트 정보를 함께 보여주는 운영 확인 화면입니다.
        표시되는 상태는 관리자가 확인할 대상 선별 기준이며 의료 진단이나 자동 판단을 의미하지 않습니다.
      </p>
    </div>);
};
export default MonitoringInfoCard;
